import { render } from "./TabellaMapP.vue?vue&type=template&id=7d8026f5&scoped=true"
import script from "./TabellaMapP.vue?vue&type=script&lang=js"
export * from "./TabellaMapP.vue?vue&type=script&lang=js"

import "./TabellaMapP.vue?vue&type=style&index=0&id=7d8026f5&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8026f5"]])

export default __exports__